import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="2" height="2" fill="white" />
      <rect x="3" width="5" height="2" fill="white" />
      <rect x="3" y="3" width="7" height="2" fill="white" />
      <rect x="3" y="6" width="2" height="2" fill="white" />
      <rect y="3" width="2" height="2" fill="white" />
      <rect y="6" width="2" height="2" fill="white" />
    </svg>
  );
};

export default memo(Icon);
